<script>
export default {
  name: 'CardFields',
  props: {
    fields: {
      type: Array,
      required: true,
    },
  },
}
</script>

<template>
  <div>
    <div v-for="(f, idx) of fields" class="flex text-sm" :key="idx">
      <div class="truncate w-24 text-gray-400" :title="f.name">
        {{ f.name }}
      </div>
      <div class="truncate flex-1" :title="f.value">
        {{ f.value }}
      </div>
    </div>
  </div>
</template>
